import UserLocationDetector from './user-location-detector';

export default UserLocationDetector;
